var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-modal"},[_c('NavOptions',{staticClass:"func-modal",attrs:{"top":_vm.setTop,"options":_vm.options},on:{"clickItem":_vm.clickHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }